import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
  Box,
} from '@mui/material';
import { Icon } from '@iconify/react';
import ContributionsList from './ContributionsList';
import { Schema } from '../../../../../amplify/data/resource';
import { SelectionSet } from 'aws-amplify/api';

const fundContributionSelectionSet = [
  'id',
  'contributionType',
  'contributionAmount',
  'contributionRate',
  'exemptPayments',
  'registryIdentifier',
  'previousRegistryIdentifier',
  'status',
  'error',
  'employeeId',
] as const;

// @ts-ignore
type FundContribution = SelectionSet<Schema['FundContribution']['type'], typeof fundContributionSelectionSet>;

interface ContributionsDialogProps {
  open: boolean;
  onClose: () => void;
  contributions: FundContribution[];
  employeeName: string;
}

const ContributionsDialog: React.FC<ContributionsDialogProps> = ({
  open,
  onClose,
  contributions,
  employeeName,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      sx={{
        '& .MuiDialog-paper': {
          borderRadius: '16px',
          width: '600px',
          height: '80vh',
          maxHeight: '800px',
        },
      }}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '20px 24px',
          borderBottom: '1px solid #E5E7EB',
        }}
      >
        <IconButton
          onClick={onClose}
          sx={{
            color: '#6B7280',
            '&:hover': {
              backgroundColor: '#F3F4F6',
            },
          }}
        >
          <Icon icon="mingcute:close-line" width={24} height={24} />
        </IconButton>
        
        <Box sx={{ textAlign: 'right' }}>
          <Typography
            variant="h6"
            fontWeight="700"
            fontFamily={'AlmoniDL'}
            sx={{ marginBottom: '4px' }}
          >
            פרטי הפרשות עובד
          </Typography>
          <Typography
            variant="body2"
            color="text.secondary"
            fontFamily={'AlmoniDL'}
          >
            {employeeName}
          </Typography>
        </Box>
      </DialogTitle>
      
      <DialogContent
        sx={{
          padding: '24px',
          direction: 'rtl',
        }}
      >
        {contributions.length > 0 ? (
          <ContributionsList contributions={contributions} />
        ) : (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              minHeight: '200px',
              flexDirection: 'column',
              gap: '16px',
            }}
          >
            <Icon icon="mingcute:document-line" width={48} height={48} color="#9CA3AF" />
            <Typography
              color="text.secondary"
              fontFamily={'AlmoniDL'}
              textAlign="center"
            >
              לא נמצאו הפרשות עבור עובד זה
            </Typography>
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ContributionsDialog; 